import React, { useContext, useState, useEffect, useCallback } from 'react';

import { fetchSectors, fetchEndpoints, exportSelectAllEndpoints } from '../../services/api';
import { accessLocalStorage, exportSelectAllQueues } from '../../services';
import { scopeByTenant } from '../../services/tenantScope';
import { buildEndpointsIndex, formatSectorLabel } from '../../utils/labelFormatters';

import PbxContext from '../../context/PbxContext';
import '../../libs/bulma.min.css';
import './FilterReportsCalls.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

  const FilterReportsCalls = ({ sendFilterDashboard, readingDb }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { endpoints,setEndpoints, verifySort, dataForRequestCalls, setDataForRequestCalls, setStorageDataReport } = getItensStateGlobal;

  const { initDate, endDate, getStatus, getType } = dataForRequestCalls;

  const [values, setValues] = useState({});
  const [sectorsDb, setSectorsDb] = useState([]);
  const [localEndpoints, setLocalEndpoints] = useState([]);

  const handleChangeValues = (item) => {
    const { name, value } = item;
    setValues((prevState) => prevState, values[name] = value )
    return;

  };
  
  const getApiEndpoints = useCallback(async () => {
    const endpointsFetcheds = await fetchEndpoints();
    const endpointsList = await exportSelectAllEndpoints();
    const endpointsConfig = buildEndpointsIndex(endpointsList);

    let endpointsReceived = (endpointsFetcheds || []).map((element) => {
      const config = endpointsConfig[`${element.resource}`];
      if (config && !isNaN(element.resource)) {
        element.name = config.display;
        element.accountcode = config.accountcode;
      }
      if (!element.hasOwnProperty('name') || !element.name) {
        element.name = element.resource;
      }
      delete element.technology;
      return element;
    });

    if (endpointsReceived) {
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let { user: { endpointsviewer, idtenant }} = dataUser;
      const visibility = endpointsviewer !== 'all' ? endpointsviewer.split(',') : [];
      endpointsReceived = scopeByTenant(endpointsReceived, (endpoint) => endpoint.accountcode, idtenant);
      
      const endpointsForViewer = visibility.length > 0 ? endpointsReceived.filter((endpoint) => {
        if(visibility.includes(endpoint.resource)) return endpoint;
      }) : endpointsReceived;
      setEndpoints(endpointsForViewer);

      return;
    }
  }, [setEndpoints]);

  const fetchQueuesAndEndpoints = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    let { user: { idtenant }} = dataUser;

    let getSectorsInDb = await exportSelectAllQueues();
    getSectorsInDb = scopeByTenant(getSectorsInDb, (queue) => queue.accountcodequeue, idtenant);
    const edtSectors = getSectorsInDb ? getSectorsInDb.map((s) => s.namequeue) : [];

    await getApiEndpoints();

    setSectorsDb(edtSectors);

    return;
  }, [getApiEndpoints]);

  const rangeHours = Array.from({ length: 24 }).map((_, index) => index.toString());

  useEffect(() => {
    fetchQueuesAndEndpoints();
  }, [fetchQueuesAndEndpoints]);

  useEffect(() => {
    setValues(dataForRequestCalls);
  }, [dataForRequestCalls]);

  return (
    <div className="filter-card">
      
      <form className="filter-form" onSubmit={(e) => e.preventDefault()}>
        <div className="filter-row">
          <div className="filter-field">
            <label className="filter-label">Data Inicial *</label>
            <input 
              className="filter-input" 
              name="initDate" 
              id="date-initial" 
              type="date" 
              defaultValue={initDate} 
              onChange={(e) => handleChangeValues(e.target)} 
            />
          </div>

          <div className="filter-field">
            <label className="filter-label">Data Final *</label>
            <input 
              className="filter-input" 
              name="endDate" 
              id="date-final" 
              type="date" 
              defaultValue={endDate} 
              onChange={(e) => handleChangeValues(e.target)} 
            />
          </div>

          <div className="filter-field">
            <label className="filter-label">Tipo</label>
            <select className="filter-select" name="getType" defaultValue={getType} onChange={(e) => handleChangeValues(e.target)}>
              <option value="">Selecione</option>
              <option value="realizada">Efetuada</option>
              <option value="recebida">Recebida</option>
              <option value="interna">Interna</option>
            </select>
          </div>

          <div className="filter-field filter-field-wide">
            <label className="filter-label">Setor</label>
            <select className="filter-select" name="sector" onChange={(e) => handleChangeValues(e.target)}>
              <option value="">Selecione</option>
              {sectorsDb.sort(verifySort).map((s, i) => <option key={i} value={s}>{formatSectorLabel(s)}</option>)}
            </select>
          </div>
        </div>

        <div className="filter-row">
          <div className="filter-field">
            <label className="filter-label">Ramal</label>
            <select className="filter-select" name="getEndpoint" onChange={(e) => handleChangeValues(e.target)}>
              <option value="">Selecione</option>
              {endpoints.filter((endpoint) => !isNaN(endpoint.resource)).sort((a, b) => a - b).map((endpoint, index) => 
                <option key={index} value={endpoint.resource}>{endpoint.name}</option>
              )}
            </select>
          </div>

          <div className="filter-field">
            <label className="filter-label">Hora Inicial</label>
            <select className="filter-select" name="initHour" onChange={(e) => handleChangeValues(e.target)}>
              <option value="">Selecione</option>
              {rangeHours.map((hour, index) => 
                <option key={index} value={`${hour.padStart(2, '0')}:00:00`}>{hour}h</option>
              )}
            </select>
          </div>

          <div className="filter-field">
            <label className="filter-label">Hora Final</label>
            <select className="filter-select" name="endHour" onChange={(e) => handleChangeValues(e.target)}>
              <option value="">Selecione</option>
              {rangeHours.map((hour, index) => 
                <option key={index} value={`${hour.padStart(2, '0')}:59:59`}>{hour}h</option>
              )}
            </select>
          </div>

          <div className="filter-field">
            <label className="filter-label">Protocolo</label>
            <input
              className="filter-input"
              name="getProtocol"
              type="text"
              placeholder="Protocolo"
              onChange={(e) => handleChangeValues(e.target)}
            />
          </div>

          <div className="filter-field">
            <label className="filter-label">Telefone</label>
            <input
              className="filter-input"
              name="telNumber"
              type="text"
              placeholder="Apenas números"
              onChange={(e) => handleChangeValues(e.target)} 
            />
          </div>
        </div>

        <div className="filter-actions">
          <button 
            className={`filter-button ${readingDb ? 'is-loading' : ''}`}
            type="submit" 
            onClick={() => sendFilterDashboard(values)}
            disabled={readingDb}
          >
            <FontAwesomeIcon icon={faFilter} />
            <span>FILTRAR</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default FilterReportsCalls;
